import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, matchPath } from 'react-router-dom'

const styles = {
  icon: {
    width: '16px',
    marginTop: '-1px'
  }
}

const SidebarNavigation = (props) => (
  props.navItems.length > 0 && (
    <aside className='sidebar' style={styles.aside}>
      <ul className='nav flex-column' style={styles.ul}>
        {props.navItems.filter(n => n.path).map((navItem, i) => (
          <li key={i}>
            <NavLink className='nav-item nav-link d-flex' to={{
              pathname: navItem.path,
              search: window.location.search
            }}>
              <span className='nav-icon-col' style={styles.iconSpan}>
                {navItem.icon && (
                  <img src={navItem.icon} className="left-nav-icon" style={styles.icon} alt={navItem.text}/>
                )}
              </span>
              <span>{navItem.text}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </aside>
  )
)

SidebarNavigation.propTypes = {
  navItems: PropTypes.array.isRequired
}

SidebarNavigation.defaultProps = {
  navItems: []
}

export default SidebarNavigation

export const isSidebarNavShow = (routes, path) => {
  const matchRoute = _.find(routes, (route) => (route.path && matchPath(path, route)))
  return !(matchRoute && matchRoute.hideSidebarNav)
}

export const getSidebarNavItems = (routes) => (
  routes
    .filter(route => route.navPosition === 'left')
    .map(route => ({ path: route.navPath || route.path, text: route.text, icon: route.icon }))
)
